/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量1
 * @export
 * @interface Col1
 */
export interface Col1 {
}

/**
 * Check if a given object implements the Col1 interface.
 */
export function instanceOfCol1(value: object): value is Col1 {
    return true;
}

export function Col1FromJSON(json: any): Col1 {
    return Col1FromJSONTyped(json, false);
}

export function Col1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col1 {
    return json;
}

export function Col1ToJSON(json: any): Col1 {
    return Col1ToJSONTyped(json, false);
}

export function Col1ToJSONTyped(value?: Col1 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

